/** @format */
import { Link } from "react-router-dom";
import { LI } from "../../../AbstractElements";

export default function POSNav() {
  return (
    <LI className="" title="POS">
      <Link to="/pos">
        <i className="fa fa-terminal" style={{ color: "white" }}></i>
      </Link>
    </LI>
  );
}
